import { Box, Typography } from "@mui/material";
import { Container } from "react-bootstrap";
import NewPaginationControl from "../components/controls_comp/control-Pagination";

export function ListView(props) {
    const {
        data,
        headerStyle,
        renderHeader,
        renderInfo,
        pages,
        records,
        onPageSelect,
        renderActions,
    } = props;

    return (
        <>
            {data?.map((item, index) => {
                return (
                    <Container className="my-3" key={item.$id}>
                        <Box sx={{
                            display: "flex",
                            flexDirection: {
                                xs: "column",
                                sm: "row",
                            },
                            border: "1px solid #dee2e6",
                            borderRadius: "5px"
                        }}>
                            <Box
                                sx={{
                                    ...headerStyle(item),
                                    padding: "5px",
                                    flexShrink: 0,
                                    border: "1px solid #dee2e6",
                                    width: {
                                        xs: "100%",
                                        sm: "30%",
                                    },
                                    maxWidth: {
                                        xs: "none",
                                        sm: "280px",
                                    },
                                }}
                            >
                                <Box style={{ padding: "5px" }}>
                                    {renderHeader?.(item)}
                                </Box>
                            </Box>
                            <Box sx={{
                                padding: "5px",
                            }}>
                                {renderInfo?.(item)}

                                <Box style={{ marginTop: "auto" }}>
                                    {renderActions?.(item, index)}
                                </Box>
                            </Box>
                        </Box>
                    </Container>
                )
            })}

            {pages && records && onPageSelect &&
                <NewPaginationControl
                    pages={pages}
                    records={records}
                    onPageSelect={(number) => {
                        onPageSelect(number);
                    }}
                />
            }
        </>
    )
}

export function ListViewHeader(props) {
    const {
        label,
        text,
        variant,
        sx,
    } = props;

    return (
        <Box>
            <Typography sx={{ ...sx }} variant={variant}>
                {label &&
                    <span>
                        {label}:{" "}
                    </span>
                }

                <span style={{ fontWeight: "bold" }}>
                    {text}
                </span>
            </Typography>
        </Box >
    )
}

export function ListViewInfo(props) {
    const {
        label,
        text,
        variant,
    } = props;

    return (
        <Typography variant={variant}>
            {label &&
                <span style={{ color: "#606060" }}>
                    {label}:{" "}
                </span>
            }

            <span style={{ fontWeight: "400" }}>
                {text}
            </span>
        </Typography>
    )
}